"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_parse_1 = require("@comunica/bus-rdf-parse");

var htmlparser2_1 = require("htmlparser2");

var stream_1 = require("stream");
/**
 * A comunica HTML RDF Parse Actor.
 * It creates an HTML parser, and delegates its events via the bus-rdf-parse-html bus to other HTML parsing actors.
 */


var ActorRdfParseHtml =
/*#__PURE__*/
function (_bus_rdf_parse_1$Acto) {
  _inherits(ActorRdfParseHtml, _bus_rdf_parse_1$Acto);

  function ActorRdfParseHtml(args) {
    _classCallCheck(this, ActorRdfParseHtml);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfParseHtml).call(this, args));
  }

  _createClass(ActorRdfParseHtml, [{
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(action, mediaType, context) {
        var _this = this;

        var quads;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                quads = new stream_1.Readable({
                  objectMode: true
                });
                quads._read =
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee2() {
                  var endBarrier, emit, error, end, htmlAction;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          // Only initialize once
                          quads._read = null; // Create callbacks action

                          endBarrier = 1;

                          emit = function emit(quad) {
                            return quads.emit('data', quad);
                          };

                          error = function error(e) {
                            return quads.emit('error', e);
                          };

                          end = function end() {
                            if (--endBarrier === 0) {
                              quads.push(null);
                            }
                          };

                          htmlAction = {
                            baseIRI: action.baseIRI,
                            context: context,
                            emit: emit,
                            end: end,
                            error: error,
                            headers: action.headers
                          }; // Register html parse listeners

                          Promise.all(_this.busRdfParseHtml.publish(htmlAction)).then(
                          /*#__PURE__*/
                          function () {
                            var _ref2 = _asyncToGenerator(
                            /*#__PURE__*/
                            _regeneratorRuntime.mark(function _callee(outputs) {
                              var htmlParseListeners, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, output, _ref3, htmlParseListener, parser;

                              return _regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      endBarrier += outputs.length;
                                      htmlParseListeners = [];
                                      _iteratorNormalCompletion = true;
                                      _didIteratorError = false;
                                      _iteratorError = undefined;
                                      _context.prev = 5;
                                      _iterator = outputs[Symbol.iterator]();

                                    case 7:
                                      if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                        _context.next = 17;
                                        break;
                                      }

                                      output = _step.value;
                                      _context.next = 11;
                                      return output.actor.run(htmlAction);

                                    case 11:
                                      _ref3 = _context.sent;
                                      htmlParseListener = _ref3.htmlParseListener;
                                      htmlParseListeners.push(htmlParseListener);

                                    case 14:
                                      _iteratorNormalCompletion = true;
                                      _context.next = 7;
                                      break;

                                    case 17:
                                      _context.next = 23;
                                      break;

                                    case 19:
                                      _context.prev = 19;
                                      _context.t0 = _context["catch"](5);
                                      _didIteratorError = true;
                                      _iteratorError = _context.t0;

                                    case 23:
                                      _context.prev = 23;
                                      _context.prev = 24;

                                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                      }

                                    case 26:
                                      _context.prev = 26;

                                      if (!_didIteratorError) {
                                        _context.next = 29;
                                        break;
                                      }

                                      throw _iteratorError;

                                    case 29:
                                      return _context.finish(26);

                                    case 30:
                                      return _context.finish(23);

                                    case 31:
                                      // Create parser
                                      parser = new htmlparser2_1.Parser({
                                        onclosetag: function onclosetag() {
                                          var _iteratorNormalCompletion2 = true;
                                          var _didIteratorError2 = false;
                                          var _iteratorError2 = undefined;

                                          try {
                                            for (var _iterator2 = htmlParseListeners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                              var htmlParseListener = _step2.value;
                                              htmlParseListener.onTagClose();
                                            }
                                          } catch (err) {
                                            _didIteratorError2 = true;
                                            _iteratorError2 = err;
                                          } finally {
                                            try {
                                              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                _iterator2.return();
                                              }
                                            } finally {
                                              if (_didIteratorError2) {
                                                throw _iteratorError2;
                                              }
                                            }
                                          }
                                        },
                                        onend: function onend() {
                                          var _iteratorNormalCompletion3 = true;
                                          var _didIteratorError3 = false;
                                          var _iteratorError3 = undefined;

                                          try {
                                            for (var _iterator3 = htmlParseListeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                              var htmlParseListener = _step3.value;
                                              htmlParseListener.onEnd();
                                            }
                                          } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                          } finally {
                                            try {
                                              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                              }
                                            } finally {
                                              if (_didIteratorError3) {
                                                throw _iteratorError3;
                                              }
                                            }
                                          }

                                          end();
                                        },
                                        onopentag: function onopentag(name, attributes) {
                                          var _iteratorNormalCompletion4 = true;
                                          var _didIteratorError4 = false;
                                          var _iteratorError4 = undefined;

                                          try {
                                            for (var _iterator4 = htmlParseListeners[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                              var htmlParseListener = _step4.value;
                                              htmlParseListener.onTagOpen(name, attributes);
                                            }
                                          } catch (err) {
                                            _didIteratorError4 = true;
                                            _iteratorError4 = err;
                                          } finally {
                                            try {
                                              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                                _iterator4.return();
                                              }
                                            } finally {
                                              if (_didIteratorError4) {
                                                throw _iteratorError4;
                                              }
                                            }
                                          }
                                        },
                                        ontext: function ontext(data) {
                                          var _iteratorNormalCompletion5 = true;
                                          var _didIteratorError5 = false;
                                          var _iteratorError5 = undefined;

                                          try {
                                            for (var _iterator5 = htmlParseListeners[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                              var htmlParseListener = _step5.value;
                                              htmlParseListener.onText(data);
                                            }
                                          } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                          } finally {
                                            try {
                                              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                                _iterator5.return();
                                              }
                                            } finally {
                                              if (_didIteratorError5) {
                                                throw _iteratorError5;
                                              }
                                            }
                                          }
                                        }
                                      }, {
                                        decodeEntities: true,
                                        recognizeSelfClosing: true,
                                        xmlMode: false
                                      }); // Push stream to parser

                                      action.input.on('error', error);
                                      action.input.pipe(parser);

                                    case 34:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, null, [[5, 19, 23, 31], [24,, 26, 30]]);
                            }));

                            return function (_x4) {
                              return _ref2.apply(this, arguments);
                            };
                          }());

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));
                return _context3.abrupt("return", {
                  quads: quads
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function runHandle(_x, _x2, _x3) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }]);

  return ActorRdfParseHtml;
}(bus_rdf_parse_1.ActorRdfParseFixedMediaTypes);

exports.ActorRdfParseHtml = ActorRdfParseHtml;